import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { currentUser, signout, quota } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const handleSignOut = async () => {
    try {
      await signout();
      closeMenu();
    } catch (error) {
      console.error("Failed to sign out", error);
    }
  };

  const navigationItems = [
    { path: '/pain-extractor', label: 'Pain Extractor', icon: 'psychology' },
    { path: '/post-enhancer', label: 'Post Enhancer', icon: 'auto_awesome' },
    { path: '/post-timer', label: 'Post Timer', icon: 'timer' }
  ];

  return (
    <header className="bg-container-light dark:bg-container-dark/80 backdrop-blur-lg sticky top-0 z-50 border-b border-border-light dark:border-border-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex-shrink-0 flex items-center" onClick={closeMenu}>
              <div className="main-logo-container">
                <span className="main-logo-text">WizeHelper</span>
              </div>
            </Link>
            <nav className="hidden md:flex items-center space-x-2">
              {navigationItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`${isActiveRoute(item.path)
                    ? "text-[#1F7A8C] font-semibold px-3 py-2 rounded-lg text-sm flex items-center gap-2 no-underline"
                    : "text-[#022B3A] hover:text-[#1F7A8C] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors no-underline"}`}
                  onClick={closeMenu}
                >
                  <span className="material-symbols-outlined text-base">{item.icon}</span>{item.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex items-center space-x-4">
            {currentUser ? (
              <div className="flex items-center gap-4">
                {typeof quota === 'number' && (
                  <div className="quota-star-container" title={`You have ${quota} free requests left`}>
                    <span className="material-symbols-outlined quota-star-icon">grade</span>
                    <span className="quota-number" style={{ paddingTop: '3px' }}>{quota}</span>
                  </div>
                )}
                <button
                  onClick={handleSignOut}
                  className="bg-[#1F7A8C] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#165C6B] transition-colors h-9 min-h-[36px] min-w-[80px] flex items-center justify-center"
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <Link to="/signin" className="bg-[#1F7A8C] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#1F7A8C] transition-colors h-9 min-h-[36px] min-w-[80px] flex items-center justify-center"
                onClick={closeMenu}>
                Sign In
              </Link>
            )}
            <button
              onClick={toggleMenu}
              className="md:hidden p-2 rounded-lg text-[#022B3A] dark:text-text-dark-primary hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              <span className="material-symbols-outlined">{isMenuOpen ? 'close' : 'menu'}</span>
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="md:hidden" id="mobile-menu">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${isActiveRoute(item.path)
                  ? "text-[#1F7A8C] font-semibold block px-3 py-2 rounded-lg text-sm flex items-center gap-2 no-underline"
                  : "text-[#022B3A] hover:text-[#1F7A8C] block px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors no-underline"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <span className="material-symbols-outlined text-base">{item.icon}</span>{item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
